import React from 'react';
import { Link } from 'react-router-dom';

const ServicesOneHiringAreaOrthopedics = () => {
    return (
        <>
            <section className="hiring-area pt-120 pb-120">
                <div className="container">
                    <div className="row no-gutters hire-bg-2">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. Sunil Kr. Singh.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>Dr. SUNIL KR. SINGH</h1>
                                <p>
                                    M.B.B.S., M.S. (Ortho) IMS BHU
                                    <br />
                                    20 years of experience in Trauma & Joint Replacement Surgery
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon btn-icon-green ml-0"><span>+</span>Contact us</Link>
                            </div>
                        </div>
                    </div>
                    <div className="row no-gutters hire-bg">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>Dr. S. KUMAR SINGH</h1>
                                <p>
                                    M.B.B.S., DNB, D. Ortho MNAMS
                                    <br />
                                    20 Years of experience of as Spine & Ortho Surgeon
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon ml-0"><span>+</span>Contact Us</Link>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. S. Kumar Singh.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ServicesOneHiringAreaOrthopedics;